import { usePartyQuery } from "Api/Queries/Party/usePartyQuery";
import { SendAccessForm } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/SendAccess/SendAccessForm";
import { SendAccessSkeleton } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/SendAccess/SendAccessSkeleton";
import { PartyType, RelationType } from "Infrastructure/Api/Api";

type Props = {
  publicPartyID: string;
  merchantPublicID: string;
};

export const SendAccess = ({ publicPartyID, merchantPublicID }: Props) => {
  const { data: partyData, isLoading: isPartyLoading } =
    usePartyQuery(publicPartyID);

  const isLegalEntity = partyData?.type === PartyType.LegalEntity;

  const firstContactPersonID = partyData?.relatedParties.find(
    ({ relationType }) => relationType === RelationType.ContactPerson,
  )?.relatedPartyPublicID;

  const { data: contactPersonData, isLoading: isContactPersonLoading } =
    usePartyQuery(isLegalEntity ? firstContactPersonID : undefined);

  if (isPartyLoading || (isLegalEntity && isContactPersonLoading)) {
    return <SendAccessSkeleton />;
  }

  const prefillEmail =
    (isLegalEntity ? contactPersonData?.email : partyData?.email) ?? "";

  return (
    <SendAccessForm
      merchantPublicID={merchantPublicID}
      prefillEmail={prefillEmail}
      partyData={partyData}
    />
  );
};
